import { render, staticRenderFns } from "./StockPage.vue?vue&type=template&id=7c85be8c&scoped=true&"
import script from "./StockPage.vue?vue&type=script&lang=js&"
export * from "./StockPage.vue?vue&type=script&lang=js&"
import style0 from "./StockPage.vue?vue&type=style&index=0&id=7c85be8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c85be8c",
  null
  
)

export default component.exports